import { createContext, FunctionComponent, useContext, useEffect, useState } from "react";
import {
  FeedbackType,
  GenestoryQuestion,
  useQuestionsForDataGroupByTypeLazyQuery,
} from "../../../../api/smartmelts-api/graphql/generated";
import { MenuSubcategoryDictionary } from "../../../../models/categories";
import { NutritionContext } from "../../context/nutrition-context";

interface IAnswerContextProviderProps {}

interface IAnswerContext {
  loading: boolean;
  questions: GenestoryQuestion[];
  setActiveIndex: (index: number) => void;
  activeIndex: number;
  activeQuestion: GenestoryQuestion;
  setActiveAnswerIndex: (index: number) => void;
  activeAnswerIndex: number;
  activeAnswer: GenestoryQuestion;
}

export const AnswerContext = createContext<IAnswerContext>({
  questions: [],
  loading: true,
  setActiveIndex: (index: number) => {},
  activeIndex: 0,
  activeQuestion: {} as GenestoryQuestion,
  setActiveAnswerIndex: (index: number) => {},
  activeAnswerIndex: 0,
  activeAnswer: {} as GenestoryQuestion,
});

export const AnswerContextProvider: FunctionComponent<IAnswerContextProviderProps> = (props) => {
  const { children } = props;

  const { activeSubcategory, isDemo, activeIndex: activeFavIndex } = useContext(NutritionContext);
  const [questions, setQuestions] = useState<GenestoryQuestion[]>([]);
  const [questionQuery, { loading }] = useQuestionsForDataGroupByTypeLazyQuery({
    onCompleted: (data) => {
      const geneStoriesByQuestion = data.questionsForDataGroupByType.filter(
        (geneStoryByQuestion: GenestoryQuestion) =>
          geneStoryByQuestion.feedbackType !== FeedbackType.STORYRECOMMENDATION &&
          geneStoryByQuestion.feedbackType !== FeedbackType.GENES,
      );
      setQuestions(geneStoriesByQuestion);
    },
    onError: () => {
      setQuestions([]);
    },
  });
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [activeAnswerIndex, setActiveAnswerIndex] = useState<number>(0);
  const activeQuestion = questions[activeIndex];
  const activeAnswer = questions[activeAnswerIndex];

  useEffect(() => {
    setQuestions([]);
    questionQuery({
      variables: { types: MenuSubcategoryDictionary[activeSubcategory].geneDataGroupTypes, demo: isDemo },
    });
    setActiveIndex(0);
    if (activeFavIndex) {
      setActiveAnswerIndex(activeFavIndex - 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSubcategory, questionQuery, isDemo]);

  return (
    <AnswerContext.Provider
      value={{
        loading,
        questions,
        setActiveIndex,
        activeIndex,
        activeQuestion,
        setActiveAnswerIndex,
        activeAnswerIndex,
        activeAnswer,
      }}
    >
      {children}
    </AnswerContext.Provider>
  );
};
